import { ROUTE_PATH_KEYS } from '@local/constants';
import actor from './Actor';
import layout from './layout';

const getRoutes = () => ({ actor, layout, params: [ROUTE_PATH_KEYS.ID] });

export default getRoutes;
